module.exports = __webpack_public_path__ + "img/47ne.bc437cdd.svg";